import { Component, input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatIconModule } from '@angular/material/icon'
import { IAsset } from 'src/app/core/interfaces/asset.interface'
import { LinkModule } from '../link/link.module'

@Component({
  selector: 'app-shipping-banner',
  templateUrl: './shipping-banner.component.html',
  styleUrls: ['./shipping-banner.component.scss'],
  imports: [CommonModule, MatIconModule, LinkModule],
})

export class ShippingBannerComponent {
  enabled = input<boolean>(false)
  asset = input<IAsset>()

  getLocationUrl() {
    if (!this.asset()) {
      return ''
    }
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(this.asset()?.branch_address + '+' + this.asset()?.branch_city + '+' + this.asset()?.branch_state + '+' + this.asset()?.branch_zipcode)}`
  }
}
